import { Box } from '@mui/material';
import { EmptyOrLoadingState } from '@src/components/EmptyOrLoadingState';
import { MoSelectAvailableDateCalendar } from '@src/components/MoSelectAvailableDateCalendar';
import { AvailableSlotsField } from '@src/components/form-fields/AvailableSlotsField';
import { DateTime } from 'luxon';
import React, { FunctionComponent, useContext, useEffect } from 'react';
import { useField } from 'react-final-form';
import invariant from 'tiny-invariant';
import { BookIntroCallContext } from './BookIntroCallProvider';

export type AvailableSlotsProps = {
  availableSlotsFieldMaxHeight?: number;
};

const SelectDateFields: FunctionComponent<AvailableSlotsProps> = ({
  availableSlotsFieldMaxHeight,
}) => {
  const context = useContext(BookIntroCallContext);
  invariant(context);
  const {
    availableWeekdays,
    availableDates,
    awayWindows,
    timeSlots,
    timeslotsLoading,
    selectedDateTime,
    setSelectedDateTime,
    singleSelect,
    onTimezoneChange,
  } = context;

  const {
    input: { value: timezone },
  } = useField('timezone');

  useEffect(() => {
    onTimezoneChange?.(timezone);
  }, [timezone, onTimezoneChange]);

  return (
    <>
      <MoSelectAvailableDateCalendar
        availableWeekdays={availableWeekdays}
        availableDates={availableDates}
        awayWindows={awayWindows}
        onChange={(value: DateTime) => {
          setSelectedDateTime(value);
        }}
        value={selectedDateTime}
      />

      {timeslotsLoading ? (
        <Box sx={{ height: 200 }}>
          <EmptyOrLoadingState loading />
        </Box>
      ) : (
        <AvailableSlotsField
          timezone={timezone}
          timeSlots={timeSlots}
          maxHeight={availableSlotsFieldMaxHeight}
          singleSelect={singleSelect}
        />
      )}
    </>
  );
};

export default SelectDateFields;
